import OpenAI from "openai";

export enum ClientAPIKey {
  OPENAI = "OPENAI",
  TOGETHER = "TOGETHER",
}

export const generateClient = (apiKey: ClientAPIKey) => {
  return new OpenAI({
    apiKey, // Required but intercepted by backend; token must match server logic
    baseURL: `${window.location.origin}/v1`, // Matches Netlify function redirect
    dangerouslyAllowBrowser: true,
  });
};
